<div>
    <div class="non-selectable d-flex gap-2 pb-2 w-full align-items-center justify-content-between"  aria-expanded="false"  [title]="isCollapsed ? 'Expand ' + buttonLabel : 'Collapse ' + buttonLabel">
      <span class="bi non-selectable" (click)="toggleCollapse()" [ngClass]="isCollapsed ? 'bi-chevron-right' : 'bi-chevron-down'">
      {{ buttonLabel }}
       <ng-content select="[label]"> </ng-content>
    </span>
      <ng-content select="[excludeButton]"> </ng-content>

    </div>
    <div class="multi-collapse" [ngClass]="{'collapse': isCollapsed}">
      <ng-content></ng-content>
    </div>
  </div>

